const appConfig = {
  "name": "elo-v2",
  "version": "0.1.0",
  "stage": "prod",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6sh93rjqnQuszg697",
    "clientId": "7l8kk34kjntpt0ufg0fkilbuuj",
    "redirectUris": [
      "https://elx-mr.atlas-apps.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://elx-mr.atlas-apps.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "digital-id/user",
      "elo/user",
      "email",
      "offline_access",
      "openid",
      "phone",
      "profile"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_bCu6BU8d2",
    "userPoolWebClientId": "7l8kk34kjntpt0ufg0fkilbuuj",
    "oauth": {
      "domain": "atlas-auth.mit.edu",
      "scope": [
        "digital-id/user",
        "elo/user",
        "openid",
        "profile"
      ],
      "redirectUris": [
        "https://elx-mr.atlas-apps.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://elx-mr.atlas-apps.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;